import styled, { css } from 'styled-components';

import { BorderRadius } from '../../../tokens/borderRadius';
import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';

export const MultiCheckbox = styled.div<{ isChecked: boolean | undefined, disabled?: boolean }>`
    display: flex;
    align-items: center;
    padding: ${p => p.isChecked ? '4px 16px' : '6px 16px'};
    column-gap: 4px;
    ${FONTS.MediumXS};
    color: ${COLORS.TextPrimary};
    white-space: nowrap;
    background-color: transparent;
    border: 2px solid ${COLORS.ButtonSecondary};
    border-radius: ${BorderRadius.OuterBlockRadius};
    transition: border 0.2s ease;
    cursor: pointer;

    @media (hover: hover) {
        &:hover {
            border: 2px solid ${COLORS.ButtonPrimary};
        }
    }

    ${p => p.isChecked && css`
        color: ${COLORS.TextWhite};
        background-color: ${COLORS.ButtonPrimary};
        border: 2px solid ${COLORS.ButtonPrimary};
    `}

    ${p => p.disabled && css`
        color: ${COLORS.TextHint};
        background-color: ${COLORS.GRAY_LIGHT};
        border: 2px solid ${COLORS.GRAY_LIGHT};
        user-select: none;

        @media (hover: hover) {
            &:hover {
                border: 2px solid ${COLORS.GRAY_LIGHT};
                cursor: default;
            }
        }
    `};
`;
